// extracted by mini-css-extract-plugin
export default {"container":"otp_container__lHJ8L","cardHeaderWrap":"otp_cardHeaderWrap__9xPDi"};